import { Meeting, MeetingType, Participant, ParticipantRole } from '@/types/meeting';

const mockParticipants: Record<ParticipantRole, Participant> = {
  TEACHER: {
    id: 't1',
    name: 'Dr. Sarah Mitchell',
    email: 'sarah.mitchell@school.edu',
    role: ParticipantRole.TEACHER,
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330',
  },
  PARENT: {
    id: 'p1',
    name: 'Michael Thompson',
    email: 'm.thompson@email.com',
    role: ParticipantRole.PARENT,
  },
  STUDENT: {
    id: 's1',
    name: 'Emma Thompson',
    email: 'emma.t@school.edu',
    role: ParticipantRole.STUDENT,
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80',
  },
  ADMIN: {
    id: 'a1',
    name: 'Principal Robert Chen',
    email: 'r.chen@school.edu',
    role: ParticipantRole.ADMIN,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e',
  },
  COUNSELOR: {
    id: 'c1',
    name: 'Lisa Martinez',
    email: 'l.martinez@school.edu',
    role: ParticipantRole.COUNSELOR,
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956',
  },
  DEPARTMENT_HEAD: {
    id: 'd1',
    name: 'Dr. James Wilson',
    email: 'j.wilson@school.edu',
    role: ParticipantRole.DEPARTMENT_HEAD,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d',
  },
};

const createMockMeeting = (
  type: MeetingType,
  title: string,
  description: string,
  participants: Participant[]
): Meeting => ({
  id: Math.random().toString(36).substr(2, 9),
  type,
  title,
  description,
  startTime: new Date(Date.now() + Math.floor(Math.random() * 7) * 24 * 60 * 60 * 1000),
  endTime: new Date(Date.now() + (Math.floor(Math.random() * 7) * 24 * 60 * 60 * 1000 + 60 * 60 * 1000)),
  location: 'Room 101',
  isVirtual: Math.random() > 0.5,
  meetingLink: 'https://meet.school.edu/room-101',
  participants,
  agenda: [
    {
      id: '1',
      title: 'Introduction',
      duration: 10,
      description: 'Meeting overview and participant introductions',
    },
    {
      id: '2',
      title: 'Main Discussion',
      duration: 30,
      description: 'Core meeting topics and discussion points',
    },
    {
      id: '3',
      title: 'Action Items',
      duration: 20,
      description: 'Review and assign action items',
    },
  ],
  tasks: [],
  notes: '',
  status: 'SCHEDULED',
});

export const mockMeetings: Meeting[] = [
  createMockMeeting(
    'PARENT_TEACHER',
    'Student Progress Review - Emma Thompson',
    'Quarterly progress review for Emma Thompson in Advanced Mathematics',
    [mockParticipants.TEACHER, mockParticipants.PARENT, mockParticipants.STUDENT],
  ),
  createMockMeeting(
    'DISCIPLINARY',
    'Behavioral Review Meeting',
    'Discussion regarding recent classroom incident',
    [mockParticipants.ADMIN, mockParticipants.TEACHER, mockParticipants.PARENT, mockParticipants.STUDENT],
  ),
  createMockMeeting(
    'ACADEMIC_REVIEW',
    'Academic Performance Review',
    'Review of student academic progress and support strategies',
    [mockParticipants.TEACHER, mockParticipants.COUNSELOR, mockParticipants.STUDENT],
  ),
  createMockMeeting(
    'TUTORING',
    'Math Tutoring Session',
    'One-on-one tutoring for Advanced Calculus',
    [mockParticipants.TEACHER, mockParticipants.STUDENT],
  ),
  createMockMeeting(
    'STAFF',
    'Monthly Staff Meeting',
    'General staff meeting to discuss school updates and policies',
    [mockParticipants.ADMIN, mockParticipants.TEACHER, mockParticipants.DEPARTMENT_HEAD],
  ),
  createMockMeeting(
    'DEPARTMENT',
    'Science Department Planning',
    'Curriculum planning and resource allocation discussion',
    [mockParticipants.DEPARTMENT_HEAD, mockParticipants.TEACHER],
  ),
  createMockMeeting(
    'IEP',
    'Individual Education Plan Review',
    'Annual IEP review and updates',
    [mockParticipants.TEACHER, mockParticipants.PARENT, mockParticipants.COUNSELOR],
  ),
  createMockMeeting(
    'COUNSELING',
    'Student Counseling Session',
    'Regular counseling check-in',
    [mockParticipants.COUNSELOR, mockParticipants.STUDENT],
  ),
  createMockMeeting(
    'CLUB',
    'Science Club Planning',
    'Planning meeting for upcoming science fair',
    [mockParticipants.TEACHER, mockParticipants.STUDENT],
  ),
  createMockMeeting(
    'ADMINISTRATIVE',
    'School Board Update',
    'Monthly progress update with school board',
    [mockParticipants.ADMIN, mockParticipants.DEPARTMENT_HEAD],
  ),
];